import React from 'react';
import styled, { css } from 'styled-components';
import CircleRightArrowIcon from '../icons/circle-right-arrow';
import Typography from '../typography';

interface HintArrowProps {
  className?: string;
  title: React.ReactNode;
  noBorderRadius?: boolean;
  noMargin?: boolean;
  onClick: () => void;
}

export const HintArrow = (props: HintArrowProps) => {
  return (
    <div className={props.className}>
      <Typography type="small" weight="700" className="text">
        {props.title}
      </Typography>
      <CircleRightArrowIcon className="icon" onClick={props.onClick} />
    </div>
  );
};

export default styled(HintArrow)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 16px 20px;
  margin-top: 3px;
  border-radius: 0px 0px 4px 4px;
  background-color: ${({ theme }) => theme.colors.blueColor};

  ${(props) =>
    props.noBorderRadius
      ? css`
          border-radius: 0;
        `
      : null}

  ${(props) =>
    props.noMargin
      ? css`
          margin: 0;
        `
      : null}

  .icon {
    width: 24px;
    height: 24px;
  }

  .text {
    color: ${({ theme }) => theme.colors.white};
  }
`;
